import { useCallback, useEffect, useMemo } from "react";


export function useResizeObserverRef(memoizedFunction: ResizeObserverCallback) {
    const resizeObserver = useMemo(()=>{
        return new ResizeObserver(memoizedFunction);
    },[memoizedFunction]);

    useEffect(()=>{
        // return resizeObserver.disconnect
    },[resizeObserver]);

    return useCallback((element: HTMLElement | null)=>{
        if(element) {
            resizeObserver.unobserve(element);
            resizeObserver.observe(element);
        }
    },[resizeObserver]);
}